import daBoiAvatar from "../client/static/da-boi.webp";
import kivo from "../client/static/examples/kivo.webp";
import messync from "../client/static/examples/messync.webp";
import microinfluencerClub from "../client/static/examples/microinfluencers.webp";
import promptpanda from "../client/static/examples/promptpanda.webp";
import reviewradar from "../client/static/examples/reviewradar.webp";
import scribeist from "../client/static/examples/scribeist.webp";
import searchcraft from "../client/static/examples/searchcraft.webp";
import { BlogUrl, DocsUrl } from "../shared/common";

export interface GridFeature {
  name: string;
  description: string;
  emoji: string;
  href: string;
  size?: 'small' | 'medium' | 'large';
}

export const features: GridFeature[] = [
  {
    name: 'Student Life Hub',
    description: 'Connect with 200+ student clubs, find social events, and build your university network.',
    emoji: '🎓',
    href: DocsUrl,
    size: 'large',
  },
  {
    name: 'Academic Resources',
    description: 'Access study groups, research opportunities, and academic support services in one place.',
    emoji: '📚',
    href: DocsUrl,
    size: 'medium',
  },
  {
    name: 'Campus Events',
    description: 'Stay updated with workshops, seminars, guest lectures, and student-led activities.',
    emoji: '📅',
    href: DocsUrl,
    size: 'medium',
  },
  {
    name: 'Housing & Dining',
    description: 'Manage residence applications and discover the best dining options across campus.',
    emoji: '🏠',
    href: DocsUrl,
    size: 'small',
  },
  {
    name: 'Sports & Athletics',
    description: 'Join intramural teams, check game schedules, and book fitness facilities.',
    emoji: '⚽',
    href: DocsUrl,
    size: 'small',
  },
  {
    name: 'Research Collaboration',
    description: 'Find research partners and keep track of ongoing projects across different departments.',
    emoji: '🔬',
    href: DocsUrl,
    size: 'small',
  },
  {
    name: 'Career Services',
    description: 'Connect with employers, find internships, and access career development workshops.',
    emoji: '💼',
    href: DocsUrl,
    size: 'medium',
  },
  {
    name: 'Health & Wellness',
    description: 'Access medical services, counseling, and mental health resources dedicated to students.',
    emoji: '🏥',
    href: DocsUrl,
    size: 'small',
  },
];

export const testimonials = [
  {
    name: 'Alexander Thompson',
    role: 'Third Year Computer Science Student',
    avatarSrc: daBoiAvatar,
    socialUrl: 'https://twitter.com/wasplang',
    quote: "Gedoba has completely changed how I navigate campus. Finding study groups and keeping track of club events is so much easier now.",
  },
  {
    name: 'Dr. Maria Garcia',
    role: 'Faculty Dean @ Science Department',
    avatarSrc: daBoiAvatar,
    socialUrl: '',
    quote: "The platform has bridge the gap between students and faculty. It's our primary tool for sharing research opportunities and academic updates.",
  },
  {
    name: 'Lucas Wright',
    role: 'Student Union President',
    avatarSrc: daBoiAvatar,
    socialUrl: '#',
    quote: "Managing student organizations and campus-wide initiatives has never been more efficient. The engagement levels are through the roof.",
  },
];

export const faqs = [
  {
    id: 1,
    question: 'How do I find a specific building on campus?',
    answer: 'You can browse buildings and facilities in the Facilities section of the dashboard to see details, events, and services associated with each location.',
  },
  {
    id: 2,
    question: 'How can I join a student club?',
    answer: 'Head over to the Student Life Hub to browse all registered organizations. You can contact club leaders and sign up for membership directly through the platform.',
  },
  {
    id: 3,
    question: 'Can I book study rooms through Gedoba?',
    answer: 'Yes! The Facility Management feature allows you to see real-time availability of study rooms across all libraries and book them for your group sessions.',
  },
  {
    id: 4,
    question: 'Is the platform accessible to all students?',
    answer: 'Absolutely. Gedoba is designed with accessibility in mind, ensuring all students can access vital campus information and resources effortlessly.',
  },
];

export const footerNavigation = {
  company: [
    { name: 'About', href: '/about' },
    { name: 'Privacy Policy', href: '/privacy' },
    { name: 'Terms of Use', href: '/terms' },
    { name: 'Contact Admin', href: '/contact' },
  ],
};

export const examples = [
  {
    name: 'Science & Innovation Complex',
    description: 'The hub for cutting-edge research, laboratories, and collaborative study spaces.',
    imageSrc: kivo,
    href: '#',
  },
  {
    name: 'Student Union Building',
    description: 'The heart of campus life featuring club offices, cafes, and social lounges.',
    imageSrc: messync,
    href: '#',
  },
  {
    name: 'Main Library & Commons',
    description: 'Rich academic resources with silent zones and group study facilities.',
    imageSrc: microinfluencerClub,
    href: '#',
  },
  {
    name: 'Athletic Performance Center',
    description: 'State-of-the-art gym, Olympic-sized pool, and varsity sports arena.',
    imageSrc: promptpanda,
    href: '#',
  },
  {
    name: 'International Student Center',
    description: 'Dedicated support for global students with cultural events and orientation.',
    imageSrc: reviewradar,
    href: '#',
  },
  {
    name: 'Arts & Media District',
    description: 'Performing arts theaters, gallery spaces, and music rehearsal studios.',
    imageSrc: scribeist,
    href: '#',
  },
  {
    name: 'Engineering South Wing',
    description: 'Home to the robotics lab and student-led maker spaces.',
    imageSrc: searchcraft,
    href: '#',
  },
];
